const DEVELOPER_USER_NAMES = [
    'Stjepan',
    'mihaela@parkdatasolutions.com',
    'svodenicar',
    'nomeragic',
    'mstocko',
];

export default function isDeveloper(userName) {
    return DEVELOPER_USER_NAMES.includes(userName);
}

export function isStjepan(userName) {
    return userName === 'Stjepan';
}
